<template> 
 <div v-show="myConfig.visible">
    <DatePicker ref="myControl" v-model="value"  :size="myConfig.size"  :format="myConfig.format"  :placeholder="myConfig.placeholder" :type="myConfig.vtype" clearable  :disabled="myConfig.readOnly" transfer   @on-change="onChange"  @on-open-change="onOpenChange" style="width:100%" />
 </div>
</template>
<script>
    import Base from '@/components/base/controlbase.vue';
    export default {
        name: 'datebox',
        extends: Base,
        data () {
            return {
                myConfig: {
                    vtype:'date',
                    format:'yyyy-MM-dd',
                    defaultValue:null
                },
                value:null,
                oldValue:null
            };
        },
        props:{
            fatherValue: {
                type: [String, Date], 
                default: null
            }
        },
        methods: {
            fatherValueToValue (value) {
                if (value) {
                    return new Date(this.fatherValue);
                } else {
                    return this.myConfig.defaultValue;
                }
            },
            onChange(e) {
                this.$nextTick(() => {
                    if (e) {
                        if (!this.value) {
                            this.value = new Date(e);
                        }
                    }
                    this.setFatherValue();
                });
            },
            valueToFatherValue() {
                let para= {};
                if (!this.value) {
                    para.value = '';
                } else {
                    if (this.myConfig.vtype ==='month') {
                        para.value = this.$Method.formatDate(this.value,'yyyy-MM-dd'); 
                    } else {
                        if (this.myConfig.format === 'MM-dd') {
                            para.value = this.$Method.formatDate(this.value,'yyyy-MM-dd'); 
                        } else {
                            para.value = this.$Method.formatDate(this.value,this.myConfig.format); 
                        }
                    }
                }
                return para;
            },
            customInit() {
                if (this.config && this.config.format  === undefined) {
                    if (this.myConfig.vtype === 'date') {
                        this.myConfig.format = 'yyyy-MM-dd';
                    } else if (this.myConfig.vtype === 'datetime') {
                        this.myConfig.format = 'yyyy-MM-dd HH:mm:ss';
                    } else if (this.myConfig.vtype ==='month') {
                        this.myConfig.format = 'yyyy-MM';
                    }
                }
            },
            onOpenChange(value) {
                if (this.config.onOpenChange) {
                    this.config.onOpenChange(value);
                }
            },
            setFocus(value) {
                if (value) {
                    this.$refs.myControl.$refs.input.focus();
                    this.$refs.myControl.isFocused = true;
                } else {
                    this.$refs.myControl.$refs.input.blur();
                    this.$refs.myControl.isFocused = false;
                }
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/datebox/datebox.vue